import "@testing-library/jest-dom";
import React from "react";
import { render, waitFor } from "@testing-library/react";
import { useChatStore } from "@metalmind-ab/mmagent-chat-ui";
import { ChatPanel } from "./ChatPanel";

const mockProviderConfigs: Array<Record<string, unknown>> = [];
jest.mock("@metalmind-ab/mmagent-chat-ui", () => {
  const actual = jest.requireActual("@metalmind-ab/mmagent-chat-ui");
  return {
    ...actual,
    ChatProvider: (props: { config: Record<string, unknown> }) => {
      mockProviderConfigs.push(props.config);
      return actual.ChatProvider(props);
    },
  };
});

let mockGetHeaders = async () => ({ Authorization: "test-token" });
const mockUploadImage = jest.fn();

jest.mock("@metalmind-ab/mmagent-chat-ui/styles.css", () => ({}), {
  virtual: true,
});
jest.mock("../../../../hooks/useAuthHeaders", () => ({
  useAuthHeaders: () => mockGetHeaders,
}));
jest.mock("../../../../hooks/useChatImageAttachments", () => ({
  useChatImageAttachments: () => ({
    enabled: false,
    uploadImage: mockUploadImage,
  }),
}));
jest.mock("../../../../config/runtimeConfig", () => ({
  getApiBaseUrl: () => "http://localhost",
}));
jest.mock("../../../../utils/chatResumeOptions", () => ({
  buildChatResumeOptions: () => ({}),
}));

const originalFetch = global.fetch;

beforeEach(() => {
  mockProviderConfigs.length = 0;
  useChatStore.getState().clearMessages();
  useChatStore.getState().setConversationId(null);
  useChatStore.getState().setConversations([], 0);
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
});

afterEach(() => {
  global.fetch = originalFetch;
  mockGetHeaders = async () => ({ Authorization: "test-token" });
});

it("fetches the conversation list once across parent rerenders with unchanged inputs", async () => {
  const fetchMock = jest.fn(
    async (_url: RequestInfo | URL) =>
      ({
        ok: true,
        json: async () => ({ items: [], total: 0 }),
      }) as Response,
  );
  global.fetch = fetchMock as unknown as typeof fetch;

  const { rerender } = render(<ChatPanel workspaceId="workspace-1" />);
  const conversationCalls = () =>
    fetchMock.mock.calls.filter(([url]) =>
      String(url).includes("/chat/conversations?"),
    );
  await waitFor(() => expect(conversationCalls()).toHaveLength(1));

  for (let i = 0; i < 5; i += 1) {
    rerender(<ChatPanel workspaceId="workspace-1" />);
  }

  // The token getter can change identity even when it returns the same token.
  mockGetHeaders = async () => ({ Authorization: "test-token" });
  rerender(<ChatPanel workspaceId="workspace-1" />);
  await Promise.resolve();

  expect(conversationCalls()).toHaveLength(1);
});

it("asks the server to confirm Stop, because the MyVault API owns the run", async () => {
  global.fetch = jest.fn(
    async () =>
      ({ ok: true, json: async () => ({ items: [], total: 0 }) }) as Response,
  ) as unknown as typeof fetch;
  mockProviderConfigs.length = 0;

  render(<ChatPanel workspaceId="workspace-1" />);
  await waitFor(() => expect(mockProviderConfigs.length).toBeGreaterThan(0));

  // The default route is {apiBaseUrl}/chat/conversations/{id}/active-submission/cancel,
  // which is the MyVault cancel route.
  expect(mockProviderConfigs[0].cancelSubmission).toBe(true);
});
